import React, { useState } from 'react';

import { PlusCircleFilled } from '@ant-design/icons';
import { Button, Col, DatePicker, Modal, Row, Space, Typography } from 'antd';
import Search from 'antd/es/input/Search';
import dayjs, { Dayjs } from 'dayjs';

import stringres from '../../translations/stringres';
import MenuMain from '../MainMenu';
import ViaggiGrid from './ViaggiGrid';
import ViaggioAddEdit from './ViaggioAddEdit';

export default function Viaggi() {
    const [refresh, setRefresh] = useState(false);
    const [descrizione, SetDescrizione] = useState('');
    const [dataInizio, setDataInizio] = useState<Dayjs>(dayjs().subtract(1, 'month'));
    const [dataFine, setdataFine] = useState<Dayjs>(dayjs().add(1, 'month'));
    const [isModalOpen, setIsModalOpen] = useState(false);

    function onClickNew() {
        setIsModalOpen(true);
    }

    function onCancel() {
        setIsModalOpen(false);
    }

    function onSearch(e) {
        SetDescrizione(e);
        setRefresh(!refresh);
    }

    return (
        <div>
            <MenuMain currentMenu="viaggi"></MenuMain>
            <Row align={'middle'} justify={'start'} className="Space-horizontal">
                <Col className="Col-Separator">
                    <label className="App-title">{stringres.t('elencoViaggi').toString()}</label>
                </Col>
                <Col className="Col-Separator">
                    <Button icon={<PlusCircleFilled />} onClick={onClickNew} type="primary">
                        {stringres.t('nuovo').toString()}
                    </Button>
                </Col>
                <Col className="Col-Separator">
                    <Search
                        placeholder={stringres.t('descrizione')}
                        allowClear
                        enterButton={stringres.t('ricerca').toString()}
                        size="large"
                        onSearch={(e) => onSearch(e)}
                    />
                </Col>
                <Col className="Col-Separator">
                    <Typography>{stringres.t('periodo').toString()}</Typography>
                </Col>
                <Col className="Col-Separator">
                    <DatePicker
                        allowClear={false}
                        size="large"
                        value={dataInizio}
                        onChange={(e) => setDataInizio(dayjs(e))}
                        placeholder={stringres.t('dataInizio').toString()}
                    ></DatePicker>
                </Col>
                <Col className="Col-Separator">
                    <DatePicker
                        allowClear={false}
                        size="large"
                        value={dataFine}
                        onChange={(e) => setdataFine(dayjs(e))}
                        placeholder={stringres.t('dataFine').toString()}
                    ></DatePicker>
                </Col>
            </Row>

            <div style={{ paddingLeft: '20px', paddingRight: '20px' }}>
                <hr></hr>
            </div>
            <Space className="App-body" direction="vertical">
                <ViaggiGrid
                    refresh={refresh}
                    dataInizio={dataInizio}
                    dataFine={dataFine}
                    descrizione={descrizione}
                ></ViaggiGrid>
            </Space>
            <Modal
                open={isModalOpen}
                title={stringres.t('dativiaggio').toString()}
                width={450}
                footer={null}
                onCancel={onCancel}
            >
                <ViaggioAddEdit width="90%" onClose={onCancel} idViaggio={null}></ViaggioAddEdit>
            </Modal>
        </div>
    );
}
